// UC Berkeley's undergraduate majors (#2596, founder 2026-09-30: "majors
// offered by the college in the public page"). Read on 2026-09-30 from the
// official UC Berkeley Undergraduate Catalog (undergraduate.catalog.berkeley.edu,
// a Coursedog site that replaced guide.berkeley.edu): every active undergraduate
// program the catalog types as a Major, grouped by the college the catalog
// assigns. The list pages 20 at a time, so the full list was read from the
// catalog's own programs search. Degrees "Bachelor of Arts/Science" shown as
// BA/BS. A joint program sits in its first college, with a note naming the
// other. Minors and the two dual-degree programs abroad (Sciences Po, University
// of Hong Kong) are left out. No flags: the college file holds no source for
// extra requirements. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-california-berkeley",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in UC Berkeley's official Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Minors, graduate programs and the dual-degree programs abroad are left out.",
    "groups": [
        {
            "name": "College of Chemistry",
            "source": {
                "label": "UC Berkeley Undergraduate Catalog, Programs: College of Chemistry, majors",
                "url": "https://undergraduate.catalog.berkeley.edu/programs?z2cJJ=College%20of%20Chemistry&ssPfM=Major"
            },
            "majors": [
                {
                    "name": "Chemical Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering/ Materials Science and Engineering Joint Major",
                    "degree": "BS",
                    "note": "Joint program with the College of Engineering"
                },
                {
                    "name": "Chemical Engineering/ Nuclear Engineering Joint Major",
                    "degree": "BS",
                    "note": "Joint program with the College of Engineering"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Computing, Data Science, and Society",
            "source": {
                "label": "UC Berkeley Undergraduate Catalog, Programs: College of Computing, Data Science, and Society, majors",
                "url": "https://undergraduate.catalog.berkeley.edu/programs?z2cJJ=College%20of%20Computing%2C%20Data%20Science%20and%20Society&ssPfM=Major"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UC Berkeley Undergraduate Catalog, Programs: College of Engineering, majors",
                "url": "https://undergraduate.catalog.berkeley.edu/programs?z2cJJ=College%20of%20Engineering&ssPfM=Major"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Aerospace Engineering and Business Administration",
                    "degree": "BS",
                    "note": "Joint program with the Haas School of Business"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Bioengineering and Business Administration",
                    "degree": "BS",
                    "note": "Joint program with the Haas School of Business"
                },
                {
                    "name": "Bioengineering/Materials Science and Engineering Joint Major",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering and Business Administration",
                    "degree": "BS",
                    "note": "Joint program with the Haas School of Business"
                },
                {
                    "name": "Electrical Engineering and Computer Science/Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering and Computer Science/Nuclear Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering and Computer Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering and Computer Sciences and Business Administration",
                    "degree": "BS",
                    "note": "Joint program with the Haas School of Business"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Energy Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Math and Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering Science",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering and Operations Research",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering and Operations Research and Business",
                    "degree": "BS",
                    "note": "Joint program with the Haas School of Business"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering and Business Administration",
                    "degree": "BS",
                    "note": "Joint program with the Haas School of Business"
                },
                {
                    "name": "Materials Science and Engineering/Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering/Nuclear Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering and Business Administration",
                    "degree": "BS",
                    "note": "Joint program with the Haas School of Business"
                },
                {
                    "name": "Mechanical Engineering/Nuclear Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Environmental Design",
            "source": {
                "label": "UC Berkeley Undergraduate Catalog, Programs: College of Environmental Design, majors",
                "url": "https://undergraduate.catalog.berkeley.edu/programs?z2cJJ=College%20of%20Environmental%20Design&ssPfM=Major"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Sustainable Environmental Design",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Letters & Science",
            "source": {
                "label": "UC Berkeley Undergraduate Catalog, Programs: College of Letters & Science, majors",
                "url": "https://undergraduate.catalog.berkeley.edu/programs?z2cJJ=College%20of%20Letters%20%26%20Science&ssPfM=Major"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Analytics",
                    "degree": "BA"
                },
                {
                    "name": "Ancient Greek and Roman Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Asian American and Asian Diaspora Studies",
                    "degree": "BA"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BA"
                },
                {
                    "name": "Celtic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chicanx Latinx Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chinese Language and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Dance and Performance Studies",
                    "degree": "BA"
                },
                {
                    "name": "Dutch Studies",
                    "degree": "BA"
                },
                {
                    "name": "Earth & Planetary Science",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Humanities",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Religion, Thought, and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "Greek",
                    "degree": "BA"
                },
                {
                    "name": "Greek and Latin",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History of Art",
                    "degree": "BA"
                },
                {
                    "name": "Integrative Biology",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Language and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Korean Language and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Life Science, Business, and Entrepreneurship",
                    "degree": "BA/BS",
                    "note": "Joint program with the Haas School of Business"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle Eastern Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Molecular and Cell Biology",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Native American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Political Economy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Rhetoric",
                    "degree": "BA"
                },
                {
                    "name": "Scandinavian",
                    "degree": "BA"
                },
                {
                    "name": "Slavic Languages and Literatures",
                    "degree": "BA"
                },
                {
                    "name": "Social Welfare",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "South and Southeast Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Portuguese",
                    "degree": "BA"
                },
                {
                    "name": "Theater & Performance Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Rausser College of Natural Resources",
            "source": {
                "label": "UC Berkeley Undergraduate Catalog, Programs: Rausser College of Natural Resources, majors",
                "url": "https://undergraduate.catalog.berkeley.edu/programs?z2cJJ=Rausser%20College%20of%20Natural%20Resources&ssPfM=Major"
            },
            "majors": [
                {
                    "name": "Conservation and Resource Studies",
                    "degree": "BS"
                },
                {
                    "name": "Ecosystem Management and Forestry",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Economics and Policy",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Genetics and Plant Biology",
                    "degree": "BS"
                },
                {
                    "name": "Microbial Biology",
                    "degree": "BS"
                },
                {
                    "name": "Molecular Environmental Biology",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Metabolic Biology",
                    "degree": "BS"
                },
                {
                    "name": "Society and Environment",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Berkeley School of Education",
            "source": {
                "label": "UC Berkeley Undergraduate Catalog, Programs: Berkeley School of Education, majors",
                "url": "https://undergraduate.catalog.berkeley.edu/programs?z2cJJ=School%20of%20Education&ssPfM=Major"
            },
            "majors": [
                {
                    "name": "Educational Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Haas School of Business",
            "source": {
                "label": "UC Berkeley Undergraduate Catalog, Programs: Haas School of Business, majors",
                "url": "https://undergraduate.catalog.berkeley.edu/programs?z2cJJ=Haas%20School%20of%20Business&ssPfM=Major"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
